module.exports = __webpack_public_path__ + "static/paymongo_currency-73ac04286a41396597e80c292a7c6cb0.png";